import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="premium-footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <h4>CH BioBank</h4>
              <p>Advancing medical research through secure, ethical biobanking. Your contribution helps discover causes, diagnostics, and treatments for diseases.</p>
            </div>
            <div className="footer-nav">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/survey">Health Survey</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/login">Dashboard Login</Link></li>
              </ul>
            </div>
            <div className="footer-contact-info">
              <h4>Contact</h4>
              <ul>
                <li><a href="mailto:info@resonancebiobank.com">info@resonancebiobank.com</a></li>
                <li><a href="tel:+914069286747">+91 40 69286747</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} <a href="/">CH BioBank.</a> All Rights Reserved.
          </p>
          <p className="footer-legal">
            <a href="/">Privacy Policy</a> | <a href="/">Terms &amp; Conditions</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
